import * as React from 'react';

interface Props {
  className?: string;
}

export class ChevronDown extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <svg
        viewBox="0 0 18 18"
        fill={`rgb(118, 118, 118);`}
        role="presentation"
        aria-hidden="true"
        focusable="false"
        className={this.props.className}
      >
        <path
          d="m16.29 4.3a1 1 0 1 1 1.41 1.42l-8 8a1 1 0 0 1 -1.41 0l-8-8a1 1 0 1 1 1.41-1.42l7.29 7.29z"
          fillRule="evenodd"
        />
      </svg>
    );
  }
}
